import { render, staticRenderFns } from "./ResourceFindManage.vue?vue&type=template&id=1741ce12&scoped=true"
import script from "./ResourceFindManage.vue?vue&type=script&lang=js"
export * from "./ResourceFindManage.vue?vue&type=script&lang=js"
import style0 from "./ResourceFindManage.vue?vue&type=style&index=0&id=1741ce12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1741ce12",
  null
  
)

export default component.exports